import { Box } from '@mui/material'
import Header from 'components/Header'
import ListNavigation from 'components/ListNavigation'
import React from 'react'
import { useParams } from 'react-router-dom'

const TransferOrder = () => {
  const { company } = useParams()
  const transferOrderOptions = [
    {
      label: 'Transfer Order Picking',
      path: '/transfer-order/transfer-order-picking'
    },
    {
      label: 'Transfer Order FBA Print',
      path: '/transfer-order/transfer-order-fba-print'
    },
    {
      label: 'Update Transfer Order Cache',
      path: '/transfer-order/update-transfer-order-cache'
    }
  ]
  return (
    <Box>
      <Header />
      <ListNavigation elements={transferOrderOptions} company={company!} />
    </Box>
  )
}

export default TransferOrder
